// import TimeIcon from './Icons/24H.png';
import CirculationIcon from './Icons/circulation.png';
import DiscordIcon from './Icons/discord.png';
// import AuctionIcon from './Icons/auction.png';
// import MarketIcon from './Icons/market.png';
// import MiningIcon from './Icons/mining.png';
import PoolIcon from './Icons/poolIcon.png';
import PeopleMiningIcon from './Icons/My_mining.png';
import TelegramIcon from './Icons/Telegram.png';
import TotalStake from './Icons/Total_stake.png';
import TwitterIcon from './Icons/twitter.png';
import Totalcost from './Icons/Total_cost.png';
import TotalSupplyIcont from './Icons/total-supply.png';
import CommunityIcon from './Icons/community.png';
import LayerIcon from './Icons/layer.png';
import SmartIcon from './Icons/smartIcon.svg';
import StatsIcon from './Icons/stats.png';
import MLDIcon from './Icons/MLD.png';
import LeftArrow from './Icons/leftArrow.png';
import RightArrow from './Icons/rightArrow.png';
import BadgeIcon from './Icons/badgeIcon.png';
import BankIcon from './Icons/BankIcon.png';
import FinanceIcon from './Icons/FinanceIcon.png';
import LiquidityIcon from './Icons/liquidity.png';
import BurnedIcon from './Icons/burned.png';
import AddIcon from './Icons/add.png';

 
export default { 
CirculationIcon:CirculationIcon,
DiscordIcon:DiscordIcon,
PoolIcon:PoolIcon,
PeopleMiningIcon:PeopleMiningIcon,
TelegramIcon:TelegramIcon,
TotalStake:TotalStake,
TwitterIcon:TwitterIcon,
Totalcost:Totalcost,
TotalSupplyIcont:TotalSupplyIcont,
CommunityIcon:CommunityIcon,
LayerIcon:LayerIcon,
SmartIcon:SmartIcon,
StatsIcon:StatsIcon,
MLDIcon:MLDIcon,
LeftArrow:LeftArrow,
RightArrow:RightArrow,
BadgeIcon:BadgeIcon,
BankIcon:BankIcon,
FinanceIcon:FinanceIcon,
LiquidityIcon:LiquidityIcon,
BurnedIcon:BurnedIcon,
AddIcon:AddIcon,
};